import { Line } from "vue-chartjs";
import { ChartConfig } from "@/config/chart.js";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "chartjs-adapter-moment";
import { APP_COLORS } from "@/config/app-colors";

export default {
  extends: Line,
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      gradient: null,
      chartOptions: {
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              tooltipItem.yLabel > 20
                ? (tooltipItem.yLabel = "> 20")
                : tooltipItem.yLabel;

              return `${data.datasets[tooltipItem.datasetIndex].label}: ${
                tooltipItem.yLabel
              }`;
            }
          }
        },
        layout: {
          padding: {
            top: 10
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        scales: {
          xAxes: [
            {
              ticks: {
                display: true,
                fontSize: ChartConfig.fontSize,
                padding: ChartConfig.padding,
                fontFamily: ChartConfig.fontFamily,
                fontColor: ChartConfig.fontColor
              },
              type: "time",
              time: {
                minUnit: "day",
                displayFormats: {
                  minute: "DD MMM YY",
                  hour: "DD MMM YY",
                  day: "DD MMM YY",
                  week: "DD MMM YY",
                  month: "DD MMM YY"
                }
              },
              display: true,
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.$t("message.common.yourPositionOnGoogleMaps"),
                fontSize: 16,
                padding: {
                  bottom: 10
                }
              },
              ticks: {
                min: 1,
                fontSize: ChartConfig.fontSize,
                padding: ChartConfig.padding,
                fontFamily: ChartConfig.fontFamily,
                fontColor: ChartConfig.fontColor,
                max: 21,
                beginAtZero: false,
                reverse: true,
                callback: function(value, index, values) {
                  values.some(val =>
                    val > 20 ? (values[values.length - 1] = 21) : false
                  );

                  if (value > 20) {
                    return "> 20";
                  }
                  return value;
                }
              }
            }
          ]
        }
      },
      chartColor: APP_COLORS.PRIMARY
    };
  },
  beforeCreate() {
    Chart.plugins.unregister(ChartDataLabels);
  },
  mounted() {
    this.$emit("loadingChartStatus", true);
    this.render();
  },
  watch: {
    labels: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    },
    data: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    }
  },
  computed: {
    formattedData() {
      return this.data.map(value => (value > 20 ? (value = 21) : value));
    }
  },
  methods: {
    render() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              label: this.$t("message.common.yourPositionOnGoogleMaps"),
              borderColor: this.chartColor,
              pointBorderColor: this.chartColor,
              pointBackgroundColor: this.chartColor,
              pointHoverBackgroundColor: this.chartColor,
              pointHoverBorderColor: this.chartColor,
              pointBorderWidth: 3,
              pointHoverRadius: 3,
              pointHoverBorderWidth: 3,
              pointRadius: 3,
              fill: false,
              clip: 3,
              backgroundColor: "transparent",
              borderWidth: 3,
              data: this.formattedData
            }
          ]
        },
        this.chartOptions
      );
    }
  }
};
